import { Injectable } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { ShareOnWebComponent } from '../components/share-on-web/share-on-web.component';


@Injectable({
    providedIn: 'root'
})
export class ShareService {

    constructor(
        public platform: Platform,
        public modalController: ModalController,
        private socialSharing: SocialSharing) {
    }

    // Share Options
    share(message?: string, subject?: string, file?: string | string[], url?: string) {
        this.platform.ready().then(async () => {
            await this.socialSharing.share(message, subject, file, url).then(() => {
            }).catch((err) => {
                this.shareOnWeb(message, subject, file, url);
                console.log(err);
            });
        });
    }

    async shareOnWeb(message?: string, subject?: string, file?: string | string[], url?: string) {
        const shareData = {
            subject,
            message,
            file,
            url
        };
        const modal = await this.modalController.create({
            component: ShareOnWebComponent,
            cssClass: 'messages-modal',
            breakpoints: [0.25, 0.5, 0.75, 1],
            initialBreakpoint: 0.5,
            componentProps: {
                shareData,
              }
        });
        return await modal.present();
        // window.navigator.share(shareData);
    }

    // Share Via Email
    shareViaEmail() {
        this.socialSharing.canShareViaEmail().then(() => {
            this.platform.ready().then(() => {
                this.socialSharing.shareViaEmail('Body', 'Subject', ['recipient@example.org']);
            });
        }).catch((err) => {
            alert('Email not available');
        });
    }

    // Share Via WhatsApp
    shareViaWhatsapp() {
        this.socialSharing.shareViaWhatsApp('Hello WhatsApp', null, 'https://codevampires.com/')
            .then(() => {
                console.log('It works');
            }).catch(() => {
                alert('WhatsApp not available');
            });
    }

    // Share Via Facebook
    shareViaFacebook() {
        this.socialSharing.shareViaFacebook('Hello Friends', null, 'https://codevampires.com/')
            .then(() => {
                console.log('It works');
            }).catch(() => {
                alert('Facebook not available');
            });
    }

    // Share Via Twitter
    shareViaTwitter() {
        this.socialSharing.shareViaTwitter('Hello Twitter', null, 'https://codevampires.com/')
            .then(() => {
                console.log('It works');
            }).catch(() => {
                alert('Twitter not available');
            });
    }

    // Share Via Instagram
    shareViaInstagram() {
        this.socialSharing.shareViaInstagram('Hello Instagram', null)
            .then(() => {
                console.log('It works');
            }).catch(() => {
                alert('Instagram not available');
            });
    }

    // Share via SMS
    shareViaSMS() {
        this.socialSharing.shareViaSMS('Hello', '+999 123123 123')
            .then(() => {
                console.log('It works');
            }).catch(() => {
                alert('Not available');
            });
    }

}
